import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import { Vector as VectorLayer } from 'ol/layer'
import { Icon, Circle as CircleStyle, Fill, Stroke, Style, Text } from 'ol/style'
import ClusterSource from 'ol/source/Cluster'
import * as turf from '@turf/turf'

const markerLayer = (geoJsonData, currentLocation, styleCache) => {
  styleCache.hovered = new Style({
    image: new Icon({
      anchor: [60, 120],
      anchorXUnits: 'pixels',
      anchorYUnits: 'pixels',
      size: [120, 120],
      scale: 0.5,
      src: 'https://cdn.mapmarker.io/api/v1/pin?size=120&background=%23288281&icon=fa-circle&color=%23FFFFFF&voffset=0&hoffset=1'
    })
  })
  const source = new VectorSource({
    format: new GeoJSON(),
    features: geoJsonData ? new GeoJSON().readFeatures(geoJsonData) : []
  })

  const clusterSource = new ClusterSource({
    distance: 30,
    source: source
  })

  const isCurrentLocationOnFeature = (feature) => {
    if (!currentLocation) {
      return false
    }
    const intersect = turf.intersect(_.get(currentLocation, 'features[0]'), new GeoJSON().writeFeatureObject(feature))
    return !!intersect
  }

  const layer = new VectorLayer({
    className: 'markerLayer',
    zIndex: 5,
    source: clusterSource,
    minResolution: 0,
    // maxResolution: 300,
    style: function (feature) {
      // console.log(feature.getGeometry().getCoordinates())
      const size = feature.get('features').length
      let style = styleCache[size]
      if (!style || size === 1) {
        style = size > 1
          ? new Style({
            image: new CircleStyle({
              radius: 14,
              stroke: new Stroke({
                color: '#fff'
              }),
              fill: new Fill({
                color: '#37817E'
              })
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: '#fff'
              })
            })
          })
          : isCurrentLocationOnFeature(feature) ? null : new Style({
            image: new Icon({
              anchor: [60, 120],
              anchorXUnits: 'pixels',
              anchorYUnits: 'pixels',
              size: [120, 120],
              scale: 0.4,
              src: 'https://cdn.mapmarker.io/api/v1/pin?size=120&background=%23288281&icon=fa-circle&color=%23FFFFFF&voffset=0&hoffset=1'
            })
          })
        styleCache[size] = style
      }
      return style
    }
  })

  // layer.setSource(source)

  return layer
}

export default markerLayer
